//env variables
export const IS_LOCALHOST: boolean = (process.env.IS_LOCALHOST ?? false) === "true";
export const DEBUG_DEV_MODE: boolean = process.env.DEBUG_DEV_MODE === "true";
export const APP_TENANT: string = process.env.APP_TENANT ?? "flow";
export const ENV: string | undefined = process.env.ENV;
export const APP_NAME: string | undefined = process.env.APP_NAME;
export const APP_API: string | undefined = process.env.APP_API;
export const ASSET_URL: string | undefined = process.env.ASSET_URL;
export const GENERAL_CDN_URL: string | undefined = process.env.GENERAL_CDN_URL;
export const STRAPI_API_URL: string = process.env.STRAPI_API_URL ?? "";
export const STRAPI_API_TOKEN: string = process.env.STRAPI_API_TOKEN ?? "";
export const GOOGLE_MAPS_KEY: string | undefined = process.env.GOOGLE_MAPS_KEY ?? "";
export const PREFERRED_URL: string = process.env.PREFERRED_URL ?? "";
export const FEATURE_HUB_KEY: string | undefined = "";
export const FEATURE_HUB_URL: string | undefined = "";
export const FEATURE_HUB_APP_ID: string | undefined = "";
export const SHOPIFY_URL: string | undefined = process.env.SHOPIFY_URL;
export const FLOCKLER_SITE_ID: string = process.env.FLOCKLER_SITE_ID ?? "";
export const FLOCKLER_ACCESS_KEY: string = process.env.FLOCKLER_ACCESS_KEY ?? "";
export const SHOPIFY_FLOW_HOUSE_SITE: string = process.env.SHOPIFY_FLOW_HOUSE_SITE ?? "";
export const SHOPIFY_FLOW_HOUSE_PUBLIC_TOKEN: string = process.env.SHOPIFY_FLOW_HOUSE_PUBLIC_TOKEN ?? "";
export const DOMAIN_WHEN_LOCALHOST: string = process.env.DOMAIN_WHEN_LOCALHOST ?? "";
export const ENABLE_TOOLKIT: boolean = process.env.ENABLE_TOOLKIT === "true";
export const DEEPKSY_IMGIX = process.env.DEEPKSY_IMGIX ?? "https://deepsky.imgix.net";
export const ZENDESK_DEAL_OWNER_ID: string = process.env.ZENDESK_DEAL_OWNER_ID ?? "";
export const ZENDESK_LEAD_OWNER_ID: string = process.env.ZENDESK_LEAD_OWNER_ID ?? "";
export const ZENDESK_SELL_ACCESS_TOKEN: string = process.env.ZENDESK_SELL_ACCESS_TOKEN ?? "";
export const LIGHTHOUSE_URL: string = process.env.LIGHTHOUSE_URL ?? "";
export const DATADOG_TOKEN: string = process.env.DATADOG_TOKEN ?? "";
export const PRELOAD_INGRESS: string = process.env.PRELOAD_INGRESS ?? "";
export const COMMON_SERVICE_URL: string = process.env.COMMON_SERVICE_URL ?? "";
export const GROWTHBOOK_URL: string = process.env.GROWTHBOOK_URL ?? "";
export const GROWTHBOOK_API: string = process.env.GROWTHBOOK_API ?? "";
export const GROWTHBOOK_CLIENT_KEY: string = process.env.GROWTHBOOK_CLIENT_KEY ?? "";

//paths set in config file
export const DEFAULT_ROUTE: string = process.env.DEFAULT_ROUTE ?? "home";
export const BROKER_LOGIN_ROUTE: string = process.env.BROKER_LOGIN_ROUTE ?? "/broker/login";

//this key is for local development only (consider how to make cloudflare auth token work for local, or other auth methods)
export const LOCAL_ONLY_COMMON_SERVICE_TOKEN: string = process.env.LOCAL_ONLY_COMMON_SERVICE_TOKEN ?? "";
